import { render, staticRenderFns } from "./heirs-grid.vue?vue&type=template&id=af0cd70a&"
import script from "./heirs-grid.vue?vue&type=script&lang=js&"
export * from "./heirs-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports